import React, { Component } from 'react'
import { Spinner, OkReportGerador } from 'scorpion-core';
import { Button, Typography, Divider } from '@material-ui/core';

import View from 'react-flexbox'

export default class ItemRelatorio extends Component {
    componentDidMount() {
        const { r } = this.props
        if (!r.nome) {
            this.props.carregarRelatorio(r.uid, (R) => console.log('CAREAGOU', R)
            );
        }
    }

    emitirRelatorio(modelo) {
        const { dados, meta } = this.props;
        OkReportGerador.imprimirDados(modelo, dados, meta)       
    }
    render() {
        const { r, index } = this.props
        if (!r.nome) {
            return <div key={index}>
                <View style={{ alignItems: "center", }}>
                    <View column>
                        <Typography variant="h6">
                            Carregando Relatório...
                        </Typography>
                    </View>

                    <Spinner />
                </View>
                <Divider />
            </div>;
        }
        return <div key={index}>
            <View style={{ alignItems: "center", }}>
                <View column>
                    <Typography variant="h6" >
                        {r.nome}
                    </Typography>
                    {r.descricao && <Typography variant="subtitle1" >
                        {r.descricao}
                    </Typography>}
                </View>

                <Button variant="contained" color="primary" onClick={() => {
                    this.emitirRelatorio(r)
                    if (this.props.actionclose)
                        this.props.actionclose()
                }
                } >Emitir</Button>
            </View>
            <Divider />


        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/OkReportDeveloper/components/ItemRelatorio/ItemRelatorio.js